import { useRef } from 'react';
import { useToast } from '@smworks-cz/ui-kit';
import type { AttachmentDTO, MeDTO } from '@sam/shared';
import { Composer, type ComposerHandle } from '../components/Composer';
import { sendMessage } from '../lib/send';
import { chatPath, navigate } from '../lib/router';
import { rememberComposerRect } from '../lib/composerMove';
import { vocative } from '../lib/format';
import { useViews } from '../lib/queries';
import { ViewsBoard } from '../components/ViewsBoard';

function greeting() {
  const h = new Date().getHours();
  return h < 5 ? 'Dobrou noc' : h < 10 ? 'Dobré ráno' : h < 18 ? 'Dobrý den' : 'Dobrý večer';
}

export function Home({ me }: { me: MeDTO }) {
  const composer = useRef<ComposerHandle>(null);
  const { toast } = useToast();
  const aiDown = me.ai !== 'ok';
  const views = useViews();

  const onSend = async (text: string, attachments: AttachmentDTO[]) => {
    try {
      rememberComposerRect(composer.current?.rect() ?? null);
      const r = await sendMessage('new', text, attachments);
      navigate(chatPath(r.conversation.id));
      return true;
    } catch (e) {
      rememberComposerRect(null);
      toast({ variant: 'error', title: (e as Error).message });
      return false;
    }
  };

  return (
    <div className="home">
      <div>
        <h1 className="greet">
          {greeting()}, {vocative(me.user.name)}
        </h1>
        <p className="greet-sub">Na co se chcete zeptat?</p>
      </div>
      <Composer ref={composer} placeholder="Zeptejte se na cokoli…" onSend={onSend} autoFocus disabled={aiDown} />
      {aiDown && <p className="ai-down">AI je teď nedostupná{me.ai === 'connecting' ? ', připojuji se znovu…' : '.'}</p>}
      {views.data && <ViewsBoard views={views.data} />}
    </div>
  );
}
